import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";
import { DatePipe } from "@angular/common";
import { environment } from "../../environments/environment";

@Component({
  selector: "app-pre-autho2",
  templateUrl: "./pre-autho2.component.html",
})
export class PreAutho2Component implements OnInit {
  couldFrontURL = environment.cloudFrontURL;
  path: any;
  scheduleappointmentid: any = "";
  countryCodeNew = "";
  scheduledview: any = {};
  scheduleDateShow: any;
  medicalqnsList: any = [];
  showExamdetails = false;
  constructor(
    private appservice: AppService,
    private datepipe: DatePipe,
    private router: Router
  ) {}

  ngOnInit() {
    if (localStorage.getItem("countryCodeNew")) {
      this.countryCodeNew = localStorage.getItem("countryCodeNew");
    }

    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length === 3) {
      this.scheduleappointmentid = Splitpath[2];
      this.viewschedule();
      this.getmedicalqns();
      this.scheduleInsuranceList();
    }
  }

  insurancename = [];
  scheduleInsuranceList() {
    this.appservice
      .scheduleInsuranceList(this.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["entity"] && res["entity"].length > 0) {
          this.insurancename = [];
          for (let index = 0; index < res["entity"].length; index++) {
            this.insurancename.push(
              res["entity"][index]["insuranceName"]);
          }
        }
      });
  }
  viewschedule() {
    this.appservice
      .viewscheduleappointment(this.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.scheduledview = res["entity"];
            this.scheduleDateShow = this.datepipe.transform(
              this.scheduledview.scheduledOn,
              "MMM d, y"
            );
            if (this.scheduledview && this.scheduledview.preAuthorized) {
              this.router.navigate([
                "/patient-profile",
                this.scheduleappointmentid,
              ]);
            }
          }
        } else {
          this.router.navigate(["/home"]);
        }
      });
  }

  showExams() {
    this.showExamdetails = true;
  }

  hideExams() {
    this.showExamdetails = false;
  }

  getmedicalqns() {
    this.appservice
      .getmedicalqns(this.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["entity"]) {
          this.medicalqnsList = res["entity"];
        }
      });
  }

  goToHomePageNew() {
    this.appservice
      .trigersmsandemail(this.scheduleappointmentid)
      .subscribe((res) => ({}));
    this.router.navigate(["/appointment", this.scheduleappointmentid]);
  }

  formatHomeDate(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let day = date.getDate();
    if (day && day < 10) {
      day = "0" + day;
    }
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return monthNames[monthIndex] + " " + day + "," + year;
  }
}
